// Sprawdzenie hasła w bazie wycieków HaveIBeenPwned (k-anonimowość) — zamiennik „Leaked password protection”,
// które w Supabase jest tylko od planu Pro (docs/kontekst/2026-10-20_HASLA-bez-Pro.md w repo mams).
// Do API idzie wyłącznie 5 pierwszych znaków skrótu SHA-1 hasła; reszta porównywana jest lokalnie.
// API jest darmowe i bez klucza. Przy błędzie sieci zwracamy 0 (nie blokujemy rejestracji).
const API = 'https://api.pwnedpasswords.com/range/';

export async function sha1Hex(text) {
  const buf = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('').toUpperCase();
}

export async function pwnedCount(password, fetchImpl = fetch) {
  try {
    if (!password || !globalThis.crypto?.subtle) return 0;
    const hex = await sha1Hex(password);
    const prefix = hex.slice(0, 5);
    const suffix = hex.slice(5);
    const res = await fetchImpl(`${API}${prefix}`, { headers: { 'Add-Padding': 'true' } });
    if (!res.ok) return 0;
    const body = await res.text();
    for (const line of body.split('\n')) {
      const [sfx, count] = line.trim().split(':');
      if (sfx === suffix) return Number(count) || 0;
    }
    return 0;
  } catch {
    return 0;
  }
}

export const PWNED_MESSAGE = 'To hasło pojawiło się w znanych wyciekach danych — wybierz inne, którego nie używasz nigdzie indziej.';
